export const ORDER_BY_OPTIONS = {
  DEFAULT: undefined,
  UNANSWERED: 'unansweredIn:asc',
  UNREAD: 'unreadIn:desc',
} as const;

export type OrderByOption =
  (typeof ORDER_BY_OPTIONS)[keyof typeof ORDER_BY_OPTIONS];
